import { createContext, useContext, useCallback } from 'react'

const TransformWrapperContext = createContext(null)

export const TransformWrapperProvider = ({ children, transformWrapperRef }) => {
  const scrollToPage = useCallback(pageNumber => e => {
    const targetPage = document.querySelector(
      `[data-page-number="${pageNumber}"]`
    )
    if (targetPage && transformWrapperRef?.current) {
      const { zoomToElement, instance } = transformWrapperRef.current
      const { scale } = instance.transformState
      zoomToElement(targetPage, scale)
      e.stopPropagation()
    }
  }, [])

  return (
    <TransformWrapperContext.Provider
      value={{ transformWrapperRef, scrollToPage }}
    >
      {children}
    </TransformWrapperContext.Provider>
  )
}

// Used to access the react-zoom-pan-pinch TransformWrapper component ref and access
// transformation controls or state outside of the TransformWrapper component tree
export const useTransformWrapper = () => {
  const context = useContext(TransformWrapperContext)
  if (context === undefined) {
    throw new Error(
      'useTransformWrapper must be used within TransformWrapperProvider'
    )
  }
  return context
}
